import { useState, useEffect, useRef } from 'react'
import classNames from 'classnames';

import Reveal from 'reveal.js'

import styles from 'styles/CharacterSelectionScreen.module.css'
import { animalSelectionAssets } from 'assets/images/AnimalSelectionScreen'
import { WebSocketContext } from "contexts/WebSocketContextProvider";
import leftArrow from 'assets/images/common/leftArrowSecondary.svg'
import rightArrow from 'assets/images/common/rightArrowSecondary.svg'

import { sendSocketMessage } from 'config/socket/socketUtil'

type ActivityType = {
  imgSrc: string
  avatar: string
}

type AnimalSelectionScreenProps = {
  firebaseRef: any;
  socketInstance: any;
}


function AnimalSelectionScreen({ firebaseRef, socketInstance } : AnimalSelectionScreenProps) {

  const slideNumberRef = useRef<number>(0)

  const assetsRef = useRef<any>(0)

  const [ currentSlide, setCurrentSlide ] = useState<number>(0)

  const [ assets, setAssets ] = useState<ActivityType[]>(animalSelectionAssets);

  useEffect(()=>{
    assetsRef.current = animalSelectionAssets;
    setAssets(animalSelectionAssets);
  }, [animalSelectionAssets])

  useEffect(() => {
    // socket.on('message', ({ className :lecture, id, message}: { className: string; id: string, message: any}) => {
    //   if( lecture === className && id === studentId && message.screen === "AnimalSelectionScreen") {
    //    if(message.navigateTo === 'left') {
    //     navigateLeft()
    //    } else if(message.navigateTo === 'right') {
    //     navigateRight()
    //    } else if(message.selectedAnimal){
    //     onSelectAnimal();
    //    }
    //   }
    // })

    const callbackFunction = (state: any) => {
      if(state.navigateTo === 'left') {
        navigateLeft()
       } else if(state.navigateTo === 'right') {
        navigateRight()
       } else if(state.selectedAnimal){
        onSelectAnimal();
       }
    }
    socketInstance.onMessage('AnimalSelectionScreen', callbackFunction)

    return ()=>{
      setCurrentSlide(0);
      setAssets([]);
    };
  },[])

  const goLeft = () => {
    // socket.emit('message', {className: className, id: studentId, message: { screen: 'AnimalSelectionScreen', navigateTo: 'left' }})
    navigateLeft()
    sendSocketMessage({ state: { navigateTo: 'left' }, action: 'AnimalSelectionScreen'})
  }

  const goRight = () => {
    // socket.emit('message', {className: className, id: studentId, message: { screen: 'AnimalSelectionScreen', navigateTo: 'right' }})
    navigateRight()
    sendSocketMessage({ state: { navigateTo: 'right' }, action: 'AnimalSelectionScreen'})
  }

  const navigateLeft = () => {
    let newArray = assets
    newArray.push(newArray.shift()!)
    setAssets([...newArray])
    slideNumberRef.current = slideNumberRef.current - 1
    setCurrentSlide(slideNumberRef.current)
  }

  const navigateRight = () => {
    let newArray = assets
    newArray.unshift(newArray.pop()!)
    setAssets([...newArray])
    slideNumberRef.current = slideNumberRef.current + 1
    setCurrentSlide(slideNumberRef.current)
  }

  const onSelectAnimal = () => {
    const selectedAnimal = assets[assets?.length-1];
    firebaseRef.update({ selectedAnimal: selectedAnimal.avatar })
    Reveal.next();
  }


  return (
    <div className={styles.container}>
      <div className={styles.slideContainer}>
        <img
          src={leftArrow}
          alt='left arrow'
          className={currentSlide === 0 ? styles.hiddenBtn : styles.image}
          onClick={goLeft}
        />
        <div className={styles.slides}>
          {assets.map((asset, i) => {
            return (
                <img
                  key={`AnimalSelectionScreen${asset.avatar}`}
                  src={asset.imgSrc}
                  className={classNames(
                    i === animalSelectionAssets.length - 1 ? styles.slideImages : styles.hidden)}
                />
            )
          })}
        </div>
        <img
          src={rightArrow}
          alt='right arrow'
          className={currentSlide === animalSelectionAssets.length - 1 ? styles.hiddenBtn : styles.image}
          onClick={goRight}
        />
      </div>
    </div>
  )
}

export default AnimalSelectionScreen
